var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.5C8.01562 0.5 0 8.58594 0 18.5C0 28.4844 8.01562 36.5 18 36.5C27.9141 36.5 36 28.4844 36 18.5C36 8.58594 27.9141 0.5 18 0.5ZM16.3125 11.1875C16.3125 10.2734 17.0156 9.5 18 9.5C18.9141 9.5 19.6875 10.2734 19.6875 11.1875V20.1875C19.6875 21.1719 18.9141 21.875 18 21.875C17.0156 21.875 16.3125 21.1719 16.3125 20.1875V11.1875ZM18 28.625C16.7344 28.625 15.75 27.6406 15.75 26.4453C15.75 25.25 16.7344 24.2656 18 24.2656C19.1953 24.2656 20.1797 25.25 20.1797 26.4453C20.1797 27.6406 19.1953 28.625 18 28.625Z",
    fill: "#D48806"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/WarningCircle.e36ebbb94e9a533156e7236970dff0de.svg";
export { ForwardRef as ReactComponent };